import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProductCard {
    productUrl: string;
    productImageUrl: string;
    inStock: boolean;
}

export interface ProductCardModal extends ProductCard {
    openModal: boolean;
}

export interface SendToAppModalSlice {
    OOSModalIsOpen: boolean;
    productCard: ProductCardModal;
}

const sendToAppModal = createSlice({
    name: "sendToAppModal",
    initialState: {
        OOSModalIsOpen: false,
        productCard: {
            productUrl: "",
            openModal: false,
        },
    } as SendToAppModalSlice,
    reducers: {
        openOOSModal(state): void {
            state.OOSModalIsOpen = true;
        },
        closeOOSModal(state): void {
            state.OOSModalIsOpen = false;
        },
        openProductCardModal(state, action: PayloadAction<ProductCard>): void {
            state.productCard = {
                productUrl: action.payload.productUrl,
                productImageUrl: action.payload.productImageUrl,
                inStock: action.payload.inStock,
                openModal: true,
            };
        },
        closeProductCardModal(state): void {
            state.productCard = {
                productUrl: "",
                productImageUrl: "",
                inStock: false,
                openModal: false,
            };
        },
    },
});

export const {
    openOOSModal,
    closeOOSModal,
    openProductCardModal,
    closeProductCardModal,
} = sendToAppModal.actions;
export default sendToAppModal.reducer;
